import React from 'react';
import { cn } from '@/lib/utils.ts';
import PrimitiveCheckbox from '@/components/form/_primitives/PrimitiveCheckbox.tsx';
import Option from '@/components/form/types/Option.ts';

const PrimitiveCheckboxGroup = ({
  options,
  value = [],
  onChange,
  name,
  disabled = false,
}: {
  options: Option[];
  value: string[];
  onChange: (values: string[]) => void;
  name?: string;
  disabled?: boolean;
}) => {
  const toggle = (optionValue: string) => {
    if (disabled) return;
    const next = value.includes(optionValue)
      ? value.filter((v) => v !== optionValue)
      : [...value, optionValue];
    onChange(next);
  };

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        const optionValue = option.value as string;
        const isChecked = value.includes(optionValue);

        return (
          <div
            key={optionValue}
            onClick={() => toggle(optionValue)}
            className={cn(
              'flex cursor-pointer items-center gap-2 rounded-sm px-3 py-1 transition hover:bg-neutral-50',
              {
                'bg-accent-400 hover:bg-accent-300': isChecked,
                'cursor-not-allowed opacity-50': disabled,
              },
            )}
          >
            <PrimitiveCheckbox
              checked={isChecked}
              disabled={disabled}
              name={name}
              readOnly
              tabIndex={-1}
            />
            <label className="pointer-events-none cursor-pointer select-none text-sm">
              {option.label}
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default PrimitiveCheckboxGroup;
